import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Capacitor } from '@capacitor/core';
import { FormField } from '../../FormField/FormField';
import { RoutineFormFieldProps } from '../types';

type StartDateFieldProps = RoutineFormFieldProps & {
  canEditStartDate: boolean;
  formattedStartDate: string | null;
};

export const StartDateField = ({
  form,
  setFormFields,
  validationErrors,
  canEditStartDate,
  formattedStartDate,
}: StartDateFieldProps) => {
  return (
    <FormField
      elementId='start-date'
      labelTitle='Fecha de inicio'
      fullWidth
      error={validationErrors?.localStartDate}
      required={canEditStartDate}
    >
      {canEditStartDate ? (
        <Calendar
          id='start-date'
          value={form?.localStartDate ? new Date(form.localStartDate) : undefined}
          onChange={(e) => setFormFields({ localStartDate: e.value?.toISOString() ?? undefined })}
          dateFormat='dd/mm/yy'
          placeholder='dd/mm/aaaa'
          minDate={new Date()}
          showIcon
          selectOtherMonths
          invalid={!!validationErrors?.localStartDate}
          touchUI={Capacitor.isNativePlatform() || window.matchMedia('(hover: none)').matches}
        />
      ) : (
        <p>{formattedStartDate}</p>
      )}
    </FormField>
  );
};
